var datalayerLogPrefix = '[ORT-DATALAYER] ';

var packshots = [];
window.isPackshotInView = function (packshot) {
  let bounding = packshot.getBoundingClientRect();
  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
};

let cookieConsentAllowed = function () {
  return 'CookieConsent' in window && CookieConsent.consent.marketing;
};

let addMethodWhenConsented = function (methodName, method, fallbackMethod, cookiesAccepted) {
  if (cookieConsentAllowed() === true) {
    console.debug(datalayerLogPrefix + 'Allowing datalayer method ', methodName);
    window[methodName] = method;
    window[methodName + '_already_allowed'] = true;
  } else {
    console.debug(datalayerLogPrefix + 'Adding fallback method until tracking consented ', methodName);
    window[methodName] = fallbackMethod;
  }
  window.addEventListener('CookiebotOnAccept', function () {
    if (cookieConsentAllowed() === true) {
      if (methodName + '_already_allowed' in window) {
        return;
      }
      console.debug(datalayerLogPrefix + 'Switching datalayer method after cookie consent', methodName);
      window[methodName] = method;
      cookiesAccepted();
    }
  });
};

let dataLayerBuffer = [];
addMethodWhenConsented(
  'pushDataLayer',
  function (data) {
    console.info(datalayerLogPrefix + 'Pushing to datalayer', data);
    window.dataLayer.push(data);
  },
  function (data) {
    console.info(datalayerLogPrefix + 'Pushing to datalayer buffer', data);
    dataLayerBuffer.push(data);
  },
  function () {
    console.info(datalayerLogPrefix + 'Pushing buffer contents to datalayer afer consent detection', dataLayerBuffer);
    dataLayerBuffer.forEach(function (item) {
      window.dataLayer.push(item);
    });
    dataLayerBuffer = [];
  }
);

// Method to register Packshots -> Packshots don`t need to be searched by this script each time
let registerPackshotFallbackCache = [];
addMethodWhenConsented(
  'registerPackshot',
  function (packshot, impression) {
    console.debug(datalayerLogPrefix + 'registerPackshot', packshot, impression);
    let data = {
      packshot: packshot,
      impression: impression,
      isVisible: window.isPackshotInView(packshot),
    };
    packshots.push(data);
  },
  function (packshot, impression) {
    console.debug(datalayerLogPrefix + 'registerPackshot(cache)', packshot, impression);
    registerPackshotFallbackCache.push({ packshot: packshot, impression: impression });
  },
  function () {
    console.debug(
      datalayerLogPrefix + 'registerPackshot processing cache after consent given',
      registerPackshotFallbackCache
    );
    registerPackshotFallbackCache.forEach(function (item) {
      window.registerPackshot(item.packshot, item.impression);
    });
    registerPackshotFallbackCache = [];
  }
);

let registerProductClickFallbackCache = [];
addMethodWhenConsented(
  'registerProductClick',
  function (targetUrl, domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerProductClick', targetUrl, domElement, impression);

    domElement.addEventListener('click', function (evt) {
      const timer = setTimeout(function () {
        console.debug(datalayerLogPrefix + 'registerProductClick -> redirecting from timer', targetUrl);
        document.location = targetUrl;
      }, 1500);
      var dataForClick = {
        event: 'productClick',
        productClick: impression,
        eventCallback: function () {
          clearTimeout(timer);
          console.debug(datalayerLogPrefix + 'registerProductClick -> redirecting event callback', targetUrl);
          document.location = targetUrl;
        },
      };
      console.debug(
        datalayerLogPrefix + 'registerProductClick -> product clicked',
        targetUrl,
        domElement,
        impression,
        'pushing to datalayer:',
        dataForClick
      );

      evt.preventDefault();
      evt.stopPropagation();
      window.dataLayer.push(dataForClick);
    });
  },
  function (targetUrl, domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerProductClick(cache)', targetUrl, domElement, impression);
    registerProductClickFallbackCache.push({ targetUrl: targetUrl, domElement: domElement, impression: impression });
  },
  function () {
    console.debug(
      datalayerLogPrefix + 'registerProductClick processing cache after consent given',
      registerProductClickFallbackCache
    );
    registerProductClickFallbackCache.forEach(function (item) {
      window.registerProductClick(item.targetUrl, item.domElement, item.impression);
    });
    registerProductClickFallbackCache = [];
  }
);
let registerCommerceCtaClickFallbackCache = [];
addMethodWhenConsented(
  'registerCommerceCtaClick',
  function (domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerCommerceCtaClick', domElement, impression);
    domElement.addEventListener('click', function () {
      var dataForClick = {
        event: 'virtualTransaction',
        virtualTransactionProduct: impression,
      };
      console.debug(
        datalayerLogPrefix + 'registerCommerceCtaClick',
        domElement,
        impression,
        'pushing to datalayer',
        dataForClick
      );
      window.dataLayer.push(dataForClick);
    });
  },
  function (domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerCommerceCtaClick(cache)', domElement, impression);
    registerCommerceCtaClickFallbackCache.push({ domElement: domElement, impression: impression });
  },
  function () {
    console.debug(
      datalayerLogPrefix + 'registerCommerceCtaClick processing cache',
      registerCommerceCtaClickFallbackCache
    );
    registerCommerceCtaClickFallbackCache.forEach(function (item) {
      window.registerCommerceCtaClick(item.domElement, item.impression);
    });
    registerCommerceCtaClickFallbackCache = [];
  }
);

let registerGenericLinkEventFallbackCache = [];
addMethodWhenConsented(
  'registerGenericLinkEvent',
  function (targetUrl, domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerGenericLinkEvent', targetUrl, domElement, impression);
    domElement.addEventListener('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      let timer = setTimeout(function () {
        console.debug(datalayerLogPrefix + 'registerGenericLinkEvent click redirecting from timer', targetUrl);
        document.location = targetUrl;
      }, 2000);
      let data = {
        event: 'genericEvent',
        eventCallback: function () {
          console.debug(
            datalayerLogPrefix + 'registerGenericLinkEvent click redirecting from event callback',
            targetUrl
          );
          clearTimeout(timer);
          document.location = targetUrl;
        },
      };

      // no Object.assign() in IE11 :(
      Object.keys(impression).forEach(function (key) {
        data[key] = impression[key];
      });

      console.debug(
        datalayerLogPrefix + 'registerGenericLinkEvent click',
        targetUrl,
        domElement,
        impression,
        'pushing to datalayer',
        data
      );

      window.dataLayer.push(data);
    });
  },
  function (targetUrl, domElement, impression) {
    console.debug(datalayerLogPrefix + 'registerGenericLinkEvent(cache)', targetUrl, domElement, impression);
    registerGenericLinkEventFallbackCache.push({
      targetUrl: targetUrl,
      domElement: domElement,
      impression: impression,
    });
  },
  function () {
    console.debug(
      datalayerLogPrefix + 'registerGenericLinkEvent processing cache',
      registerGenericLinkEventFallbackCache
    );
    registerGenericLinkEventFallbackCache.forEach(function (item) {
      window.registerGenericLinkEvent(item.targetUrl, item.domElement, item.impression);
    });
    registerGenericLinkEventFallbackCache = [];
  }
);

addMethodWhenConsented(
  'gtmObenNavClicked',
  function (evt, title, targetUrl) {
    console.info(datalayerLogPrefix + 'gtmObenNavClicked', evt, title, targetUrl);
    if (evt.target.className.indexOf('expand') > -1) {
      console.info(datalayerLogPrefix + 'gtmObenNavClicked aborting, no expander');
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    const timer = setTimeout(function () {
      console.info(datalayerLogPrefix + 'gtmObenNavClicked(click) redirecting from timer', targetUrl);
      document.location = targetUrl;
    }, 2000);
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Navigation',
      eventAction: 'Oben',
      eventLabel: title,
      eventCallback: function () {
        clearTimeout(timer);
        console.info(datalayerLogPrefix + 'gtmObenNavClicked(click) redirecting from event callback', targetUrl);
        document.location = targetUrl;
      },
    });
  },
  function () {
    // do nothing
  },
  function () {}
);
addMethodWhenConsented(
  'gtmFlyoutNavClicked',
  function (evt, title, targetUrl, target) {
    console.info(datalayerLogPrefix + 'gtmFlyoutNavClicked', evt, title, targetUrl, target);
    if (evt.target.className.indexOf('expand') > -1) {
      console.info(datalayerLogPrefix + 'gtmFlyoutNavClicked aborting, no expander');
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    const timer = setTimeout(function () {
      console.info(datalayerLogPrefix + 'gtmFlyoutNavClicked(click) redirecting from timer', targetUrl);
      if (target === '_blank') {
        window.open(targetUrl, '_blank');
        return;
      }
      document.location = targetUrl;
    }, 2000);
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Navigation',
      eventAction: 'Flyout',
      eventLabel: title,
      eventCallback: function () {
        clearTimeout(timer);
        console.info(datalayerLogPrefix + 'gtmFlyoutNavClicked(click) redirecting from timer', targetUrl);
        if (target === '_blank') {
          window.open(targetUrl, '_blank');
          return;
        }
        document.location = targetUrl;
      },
    });
  },
  function () {
    // do nothing
  },
  function () {}
);
addMethodWhenConsented(
  'gtmFooterLinkClicked',
  function (evt, name, targetUrl) {
    console.info(datalayerLogPrefix + 'gtmFooterLinkClicked', evt, targetUrl);
    evt.preventDefault();
    evt.stopPropagation();
    const target = evt.target.target || '_self';
    const timer = setTimeout(function () {
      console.info(datalayerLogPrefix + 'gtmFooterLinkClicked(click) redirecting from timer', targetUrl);
      open(targetUrl, target);
    }, 2000);
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Navigation',
      eventAction: 'Footer',
      eventLabel: name,
      eventCallback: function () {
        clearTimeout(timer);
        console.info(datalayerLogPrefix + 'gtmFooterLinkClicked(click) redirecting from timer', targetUrl);
        open(targetUrl, target);
      },
    });
  },
  function () {
    // do nothing
  },
  function () {}
);
addMethodWhenConsented(
  'gtmFlagLanguageClicked',

  function (e, targetUrl) {
    console.info(datalayerLogPrefix + 'gtmFlagLanguageClicked', e, targetUrl);
    e.preventDefault();
    e.stopPropagation();
    let sender = e.srcElement;
    if (sender == null) {
      sender = e.target;
    }
    if (sender.tagName == 'IMG') {
      sender = sender.parentNode;
    }
    let url = sender.getAttribute('href');
    let language = url.split('/')[1];

    const timer = setTimeout(function () {
      console.info(datalayerLogPrefix + 'gtmFlagLanguageClicked(click) redirecting from timer', targetUrl);
      document.location = targetUrl;
    }, 2000);
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Sprachauswahl',
      eventAction: language,
      eventCallback: function () {
        clearTimeout(timer);
        console.info(datalayerLogPrefix + 'gtmFlagLanguageClicked(click) redirecting from event callback', targetUrl);
        document.location = targetUrl;
      },
    });
  },
  function () {
    // do nothing
  },
  function () {}
);
addMethodWhenConsented(
  'gtmSocialLinkClicked',
  function (e) {
    e.preventDefault();
    e.stopPropagation();
    let pattern = /(.+:\/\/)?([^/]+)(\/.*)*/i;
    let sender = e.srcElement;
    if (sender == null) {
      sender = e.target;
    }
    if (sender.tagName === 'IMG') {
      sender = sender.parentNode;
    }
    let url = sender.getAttribute('href');
    let linkTarget = sender.getAttribute('target');
    let urlParts = pattern.exec(url);
    let platform = urlParts[2];
    const timer = setTimeout(function () {
      if (linkTarget) {
        window.open(url, linkTarget);
      } else {
        document.location = url;
      }
    }, 2000);
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Social Button',
      eventAction: platform,
      eventCallback: function () {
        clearTimeout(timer);
        if (linkTarget) {
          window.open(url, linkTarget);
        } else {
          document.location = url;
        }
      },
    });
  },
  function () {
    // do nothing
  },
  function () {}
);
addMethodWhenConsented(
  'gtmDownloadLeaflet',
  function (e, product, targetUrl) {
    e.preventDefault();
    e.stopPropagation();
    let download = function () {
      let elem = document.createElement('a');
      elem.href = targetUrl;
      elem.download = product;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    };
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Beipackzettel',
      eventAction: 'Download',
      eventLabel: product,
      eventCallback: download,
    });
  },
  function () {},
  function () {}
);

addMethodWhenConsented(
  'gtmDosageformDropdownToggle',
  function (evt) {
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Darreichungsform',
      eventAction: 'Mehr Info',
      eventLabel: evt.currentTarget.innerText,
    });
  },
  function () {},
  function () {}
);

addMethodWhenConsented(
  'gtmNewsletterSubscribed',
  function (subscriptionResponse) {
    if (subscriptionResponse.indexOf('Fehler') >= 0) {
      return;
    }
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Newsletter',
      eventAction: 'Abonnieren',
    });
  },
  function () {},
  function () {}
);

var formSubmitted = false;

addMethodWhenConsented(
  'gtmContactFormSubmit',
  function (e) {
    if (formSubmitted) {
      console.error(datalayerLogPrefix + ' gtmContactFormSubmit() -> already submitted');
      return;
    }
    console.error(datalayerLogPrefix + ' gtmContactFormSubmit()');

    e.preventDefault();
    e.stopPropagation();

    let form = document.getElementById('formContact');
    console.log(datalayerLogPrefix + ' gtmContactFormSubmit() found form', form);
    let sendForm = function () {
      if (formSubmitted) {
        console.error(datalayerLogPrefix + ' gtmContactFormSubmit()->send() -> already submitted');
        return;
      }
      formSubmitted = true;
      console.log(datalayerLogPrefix + ' gtmContactFormSubmit() sendform');
      let elem = document.createElement('input');
      elem.type = 'submit';
      form.appendChild(elem);
      elem.click();
      form.removeChild(elem);
    };
    let isFormValid = function () {
      let requiredElements = document.querySelectorAll('form [required]');
      let errors = '';
      for (let i = 0; i < requiredElements.length; i++) {
        if (!requiredElements[i].checkValidity()) {
          errors += requiredElements[i].name + ' is invalid, ';
        }
      }
      if (errors.length > 0) {
        form.reportValidity();
        window.dataLayer.push({
          event: 'genericEvent',
          eventCategory: 'Form Error',
          eventAction: 'kontakt',
          eventLabel: errors,
        });
        return false;
      }
      return true;
    };
    var isFormValidResult = isFormValid();
    console.log(datalayerLogPrefix + ' gtmContactFormSubmit() isFormValidResult', isFormValidResult);
    if (isFormValidResult === true) {
      let subjectEl = document.getElementById('txtSubject');
      let subject = subjectEl === null ? document.location.href : subjectEl.value;

      let dlEvent = {
        event: 'genericEvent',
        eventCategory: 'Kontaktformular',
        EventAction: 'Submission',
        eventLabel: subject,
        eventCallback: sendForm,
      };
      console.log(datalayerLogPrefix + ' gtmContactFormSubmit() pushing to datalayer', dlEvent);
      window.dataLayer.push(dlEvent);
      return;
    }
  },
  function () {
    return true;
  },
  function () {}
);

addMethodWhenConsented(
  'gtmMatrixCodeCheck',
  function () {
    window.dataLayer.push({
      event: 'genericEvent',
      eventCategory: 'Andere',
      eventAction: 'Packungscodeabfrage',
    });
  },
  function () {},
  function () {}
);

let transferCCTrackingFromAttributeToCookie = function () {
  // Search for an elemenr with a "data-trackingid" 
  const trackingId = document.querySelector('[data-trackingid]');
  if (trackingId) {
    const trackingIdValue = trackingId.getAttribute('data-trackingid');
    if (trackingIdValue && trackingIdValue !== '' && trackingIdValue !== 'www.orthomol.com') {
      const trackingIdValueDecoded = decodeURIComponent(trackingIdValue);
      console.log(datalayerLogPrefix + 'transferCCTrackingFromAttributeToCookie() found trackingId in attribute', trackingIdValueDecoded);
      // set cookie with the trackingIdValue
      createCookie('ccTracking', trackingIdValueDecoded, 30);
    } else {
      console.log(datalayerLogPrefix + 'transferCCTrackingFromAttributeToCookie() found trackingId in attribute, but it is not valid', trackingIdValue);
    }
  } else {
    console.log(datalayerLogPrefix + 'transferCCTrackingFromAttributeToCookie() no trackingId found');
  }
};

addMethodWhenConsented(
  'setCCTrackingCookie',
  transferCCTrackingFromAttributeToCookie,
  function () {
    console.log(datalayerLogPrefix + 'setCCTrackingCookie(), no consent given, skipping for now');
  },
  transferCCTrackingFromAttributeToCookie
);

let handler = function () {
  // check if packshots in view
  let impressions = [];
  for (let i = 0; i < packshots.length; i++) {
    if (window.isPackshotInView(packshots[i]['packshot'])) {
      if (!packshots[i]['isVisible']) {
        impressions.push(packshots[i]['impression']);
        packshots[i]['isVisible'] = true;
      }
    } else {
      packshots[i]['isVisible'] = false;
    }
  }
  if (impressions.length === 0) {
    return;
  }
  window.dataLayer.push({
    event: 'productImpressions',
    productImpression: impressions,
  });
  // push event to gtm
};

window.gtag = function () {
  window.dataLayer.push(arguments);
};

window.initDataLayer = function () {
  console.info(datalayerLogPrefix + 'init');
  if (typeof window.siteType === 'undefined' || window.siteType === '') {
    console.debug(datalayerLogPrefix + 'determining site type');
    window.siteType = 'desktop';
    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile || (window.innerWidth || document.documentElement.clientWidth) < 992) {
      window.siteType = 'mobile';
    }
  } else {
    console.log(datalayerLogPrefix + 'site type already known from backend', window.siteType);
  }

  if (typeof window.loginStatus === 'undefined' || window.loginStatus === '') {
    console.debug(datalayerLogPrefix + 'determining login status');
    window.loginStatus = 'notLoggedIn';
    let loggedInPattern = /(.*)\/fachkreise\/(.+)$/;
    if (loggedInPattern.test(location.href)) {
      window.loginStatus = 'loggedIn';
    }
  } else {
    console.debug(datalayerLogPrefix + 'login status already known from backend', window.loginStatus);
  }

  // vars are set in TrackingController
  window.dataLayer = window.dataLayer || [];
  window.gtag('js', new Date());
  if (typeof gtmId !== 'undefined' && typeof optimizeId !== 'undefined') {
    window.gtag('config', gtmId, { optimize_id: optimizeId });
  } else {
    console.info(datalayerLogPrefix + ' gtmId oder optimizeId undefined');
  }
  window.dataLayer.push({
    pageType: window.pageType,
    siteType: window.siteType,
    language: window.language,
    loginStatus: window.loginStatus,
    canonicalUrl: window.canonicalUrl,
    userId: window.userId,
    pId: window.pId,
    dcId: window.dcId,
  });
  console.debug(datalayerLogPrefix + 'initialized datalayer object', Object.assign({}, window.dataLayer));

  if (window.productId !== '') {
    window.dataLayer[window.dataLayer.length - 1]['product'] = {
      id: window.productId,
      name: window.productName,
      price: window.productPrice,
      category: window.productCategory,
    };
    console.log(datalayerLogPrefix + 'amended product data', Object.assign({}, window.dataLayer));
  }

  setCCTrackingCookie();
};

addEventListener('DOMContentLoaded', handler, false);
addEventListener('load', handler, false);
addEventListener('scroll', handler, false);
addEventListener('resize', handler, false);
